<script setup lang="ts">
/** 右栏外壳：属性 / 排列 / 色板 三个页签 */
import { ui, setInspectorTab } from '@/stores/editor';
import ArrangePanel from './ArrangePanel.vue';
import CanvasPanel from './CanvasPanel.vue';
import ElementProps from './ElementProps.vue';
import PalettePanel from './PalettePanel.vue';
</script>

<template>
  <aside class="insp" aria-label="属性">
    <div class="tabs">
      <button class="tab" :class="{ 'is-active': ui.inspectorTab === 'props' }" @click="setInspectorTab('props')">
        属性
      </button>
      <button class="tab" :class="{ 'is-active': ui.inspectorTab === 'arrange' }" @click="setInspectorTab('arrange')">
        排列
      </button>
      <button class="tab" :class="{ 'is-active': ui.inspectorTab === 'canvas' }" @click="setInspectorTab('canvas')">
        画布
      </button>
      <button class="tab" :class="{ 'is-active': ui.inspectorTab === 'palette' }" @click="setInspectorTab('palette')">
        色板
      </button>
    </div>
    <!--
      注意：三个面板都是**多根**组件，v-show 挂在组件上会失效（Vue 会警告并退化成始终渲染），
      所以每层外面必须各套一个单根容器。
    -->
    <div class="insp-body">
      <div v-show="ui.inspectorTab === 'props'" class="panel-slot">
        <ElementProps />
      </div>
      <div v-show="ui.inspectorTab === 'arrange'" class="panel-slot">
        <ArrangePanel />
      </div>
      <div v-show="ui.inspectorTab === 'canvas'" class="panel-slot">
        <CanvasPanel />
      </div>
      <div v-show="ui.inspectorTab === 'palette'" class="panel-slot">
        <PalettePanel />
      </div>
    </div>
  </aside>
</template>
